// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__36R-2","label":"styles_label__116M3"};